import { render, staticRenderFns } from "./RemPassword.vue?vue&type=template&id=fb5fc628&"
import script from "./RemPassword.vue?vue&type=script&lang=js&"
export * from "./RemPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports